module.exports = __webpack_public_path__ + "static/fonts/LavaPro-Med.86ce380.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/LavaPro-Med.eot
// module id = uSaB
// module chunks = 0